document.addEventListener('click', function (event) {
  const arrow = event.target.closest('.cart-recos__arrow');
  if (!arrow) return;
  event.preventDefault();

  const wrapper = arrow.closest('.cart-recos');
  const track = wrapper ? wrapper.querySelector('.cart-recos__track') : null;
  if (!track) return;

  const amount = track.clientWidth * 0.8;
  track.scrollBy({ left: arrow.dataset.dir === 'next' ? amount : -amount, behavior: 'smooth' });
});

document.addEventListener('click', async function (event) {
  const btn = event.target.closest('.cart-recos__add');
  if (!btn) return;
  event.preventDefault();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    const parser = new DOMParser();

    if (data.sections && data.sections['cart-drawer']) {
      const parsed = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
      const fresh = parsed.querySelector('#CartDrawer');
      const current = document.querySelector('#CartDrawer');
      if (fresh && current) current.replaceWith(fresh);
    }

    if (data.sections && data.sections['cart-icon-bubble']) {
      const parsed = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      const fresh = parsed.querySelector('.shopify-section');
      const current = document.querySelector('#cart-icon-bubble');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
    }
  } catch (e) {
    console.error('Add to cart failed', e);
  } finally {
    btn.disabled = false;
    btn.textContent = original;
  }
});